export default __webpack_public_path__ + "static/media/right-arrow.58953156.svg";